export default function Features() {
  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        {/* Top Section */}
        <div className="flex justify-between items-start mb-20">
          <h2 className="text-6xl font-light text-gray-900 leading-tight w-2/5" style={{ fontFamily: 'Georgia, serif' }}>
            Why Choose<br />OGIN
          </h2>
          <p className="text-base text-gray-600 leading-relaxed w-1/3">
            We combine cutting-edge technology with user-centric design to deliver iOS applications that prioritize security, performance, and ease of use. Our commitment to excellence ensures your mobile experience is both safe and seamless.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-12 gap-6">
          {/* Large Feature Card */}
          <div className="col-span-5 bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 h-[600px] flex flex-col">
            <h3 className="text-3xl font-medium text-white mb-4">Enterprise Security</h3>
            <p className="text-sm text-gray-300 mb-8">Military-grade encryption protecting your data</p>
            <div className="flex-1 flex items-end">
              <img 
                src="https://public.readdy.ai/ai/img_res/aae796efcdc31f0fdc231eb82d393c95.jpg" 
                alt="Enterprise Security" 
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>

          {/* VPN Pro Card */}
          <div className="col-span-3 bg-white rounded-3xl p-10 h-[600px] flex flex-col shadow-md relative">
            <div className="absolute top-8 left-8 bg-gray-100 rounded-full px-3 py-1 flex items-center gap-1">
              <i className="ri-star-fill text-xs text-yellow-500"></i>
              <span className="text-xs uppercase font-medium text-gray-700">FEATURED</span>
            </div>
            <div className="flex-1 flex flex-col items-center justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20mockup%20showing%20VPN%20Pro%20application%20with%20world%20map%20server%20locations%20and%20connection%20speed%20meter%20on%20clean%20white%20background%20premium%20iOS%20interface%20design%20with%20modern%20typography&width=400&height=600&seq=vpn-pro-feature-001&orientation=portrait" 
                alt="VPN Pro" 
                className="w-40 h-auto object-contain mb-8"
              />
              <h3 className="text-2xl font-semibold text-gray-900 mb-2">VPN Pro</h3>
              <p className="text-sm text-gray-600">Advanced encryption</p>
            </div>
          </div>

          {/* Cleaner Pro Card */}
          <div className="col-span-4 bg-white rounded-3xl p-10 h-[600px] flex flex-col shadow-md">
            <div className="flex-1 flex flex-col items-center justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20displaying%20advanced%20cleaner%20application%20with%20storage%20analysis%20pie%20charts%20duplicate%20file%20finder%20and%20memory%20optimization%20tools%20on%20light%20background%20modern%20iOS%20design%20with%20colorful%20data%20visualization&width=400&height=600&seq=cleaner-pro-feature-001&orientation=portrait" 
                alt="Cleaner Pro" 
                className="w-40 h-auto object-contain mb-8"
              />
              <h3 className="text-2xl font-semibold text-gray-900 mb-2">Cleaner Pro</h3>
              <p className="text-sm text-gray-600">Deep system optimization</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
